<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  WEB_APP_URL
} from '~/constants/website'

const props = defineProps<{
  title?: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="
      cn(
        'flex flex-col lg:flex-row lg:items-center gap-2 justify-between lg:p-8 lg:bg-surface-container-high rounded-3xl',
        props.class
      )
    "
  >
    <h2
      class="font-bold text-[1.25rem] leading-[1.5rem] lg:leading-[2.1rem] tracking-[0.01rem] lg:text-[1.75rem] text-on-background font-display mb-3 lg:mb-0"
    >
      {{ title ?? 'Coba Aplikasi KiriminAja Sekarang!' }}
    </h2>
    <div class="space-y-3">
      <div class="flex items-center gap-[0.625rem]">
        <NuxtLink
          :to="$utm.utmUrl(GOOGLE_PLAY_URL, undefined, true)"
          rel="noopener noreferrer"
          class="inline-block"
        >
          <NuxtImg
            alt="playstore"
            width="177px"
            height="52px"
            src="/images/home-v4/playstore.webp"
            class="max-w-full max-h-13"
          />
        </NuxtLink>
        <NuxtLink
          :to="$utm.utmUrl(APP_STORE_URL)"
          rel="noopener noreferrer"
          class="inline-block"
        >
          <NuxtImg
            alt="appstore"
            width="177px"
            height="52px"
            src="/images/home-v4/appstore.webp"
            class="max-w-full max-h-13"
          />
        </NuxtLink>
      </div>
      <p class="text-left lg:text-right">
        Atau versi
        <a
          :href="$utm.utmUrl(WEB_APP_URL)"
          rel="noopener noreferrer"
          class="text-lg font-bold underline"
          >Web Dashboard</a
        >
      </p>
    </div>
  </div>
</template>
